<form novalidate #activitiesForm="ngForm" style="height:100%" cdkDrag cdkDragBoundary=".cdk-overlay-container" cdkDragRootElement=".cdk-overlay-pane">
  <div class="activities-control">
    <div class="activities-content">

      @if (activitiesService.queryActivitiesForPropertyAndDateRange.isFetching()) {
      <div class="spinner-container">
        <mat-spinner></mat-spinner>
        <label class="spinner-loading-label">Loading Activities, please wait...</label>
      </div>
      }
      @else if (activitiesService.lastFetchError()) {
      <div class="spinner-container">
        <mat-icon color="warn">error</mat-icon>
        <label class="spinner-loading-label">Failed to load activities: {{ activitiesService.lastFetchError() }}</label>
      </div>
      }
      @else if (!activitiesService.tabs() || activitiesService.tabs().length === 0) {
      <div class="spinner-container">
        <mat-spinner></mat-spinner>
        <label class="spinner-loading-label">Loading Activities, please wait...</label>
      </div>
      }
      @else {
      <div class="activities-header">
        <mat-icon class="drag-handle-icon" cdkDragHandle>drag_handle</mat-icon>
        <div class="tab-group-wrapper">
          <mat-tab-group #tabGroup id="tabGroup"
                         [selectedIndex]="activitiesService.tabSelectedIndex()"
                         (selectedIndexChange)="activitiesService.tabSelectedIndex.set($event)">
            @for (tab of activitiesService.tabs(); track tab.content.Id; let index = $index) {
            <mat-tab>
              <ng-template mat-tab-label>
                <div [ngClass]="tab.header.headerClass">
                  <div class="tab-label">
                    {{tab.header.headerText}}
                    <mat-icon class="tab-clear-icon" (click)="removeTab(index)">close</mat-icon>
                  </div>
                </div>
              </ng-template>
              <mat-card appearance="outlined">
                <mat-card-content>
                  <activity [activityData]="tab.content"
                            [spotSoldInRange]="spotSold"
                            [closeAfterSave]="activitiesService.closeAfterSave"
                            [delegateCancelButtonToParent]="false"
                            (activityHeaderTextChange)="activityHeaderTextChange($event)"
                            (statusChange)="statusChange($event)"
                            (copyActivity)="copyActivity($event)"
                            (activitySaved)="activitySaved($event)"
                            (cancelButtonClicked)="cancelButtonClicked($event)">
                  </activity>
                </mat-card-content>
              </mat-card>
            </mat-tab>
            }
          </mat-tab-group>
        </div>
        <div class="add-tab">
          @if (canAddActivity && !spotSold) {
          <button mat-icon-button (click)="addTab()" title="Add new activity for property">
            <mat-icon class="add-tab-icon">add_circle</mat-icon>
          </button>
          }
        </div>
      </div>
      }

    </div>
  </div>
</form>
